import * as ModuleIcons from '@factorialco/factorial-one-react/icons/modules'

export const moduleIcons = (moduleIdentifier: string) => {
  switch (moduleIdentifier) {
    case 'projects':
      return ModuleIcons.Projects
    case 'shift_management':
      return ModuleIcons.Shifts
    case 'benefits':
      return ModuleIcons.Benefits
    case 'space_control':
      return ModuleIcons.Spaces
    case 'finance':
      return ModuleIcons.Finance
    case 'trainings':
      return ModuleIcons.Trainings
    case 'ats':
      return ModuleIcons.Recruitment
    case 'reviews':
      return ModuleIcons.Performance
    case 'goals':
      return ModuleIcons.Performance
    case 'competencies':
      return ModuleIcons.Performance
    case 'engagement_insights':
      return ModuleIcons.Engagement
    case 'surveys':
      return ModuleIcons.Engagement
    case 'enps':
      return ModuleIcons.Engagement
    case 'expenses':
      return ModuleIcons.Spending
    case 'timeoff':
      return ModuleIcons.TimeOff
    case 'time_tracking':
      return ModuleIcons.TimeTracking
    case 'procurement':
      return ModuleIcons.Spending
    case 'accounts_payable':
      return ModuleIcons.Spending
    case 'sales':
      return ModuleIcons.Sales
    case 'default':
      return ModuleIcons.Hub
    default:
      return ModuleIcons.Discover
  }
}
